interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  hint?: string
  disabled?: boolean
  size?: 'sm' | 'md'
  /** Accessible name for the switch when no visible `label` is rendered
   *  next to it (e.g. a per-row toggle in a list that already shows its
   *  own label elsewhere) — falls back to `label` when omitted. */
  ariaLabel?: string
}

export function Toggle({ checked, onChange, label, hint, disabled, size = 'md', ariaLabel }: ToggleProps) {
  const w = size === 'sm' ? 32 : 40
  const h = size === 'sm' ? 18 : 22
  const dot = size === 'sm' ? 14 : 18
  const offset = checked ? w - dot - 2 : 2

  return (
    <label className={`inline-flex items-center gap-2.5 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel ?? label}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className="relative flex-shrink-0 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
        style={{
          width: w,
          height: h,
          background: checked ? '#0d7c76' : '#cbd5e1',
          transition: 'background 200ms ease',
        }}
      >
        <span
          className="absolute top-1/2 rounded-full bg-white shadow-sm"
          style={{
            width: dot,
            height: dot,
            left: offset,
            transform: 'translateY(-50%)',
            transition: 'left 200ms cubic-bezier(0.2,0.8,0.2,1)',
          }}
        />
      </button>
      {(label || hint) && (
        <div className="min-w-0">
          {label && <div className={`font-semibold text-on-surface ${size === 'sm' ? 'text-[11px]' : 'text-[12px]'}`}>{label}</div>}
          {hint && <div className={`text-on-surface-variant ${size === 'sm' ? 'text-[9px]' : 'text-[10px]'}`}>{hint}</div>}
        </div>
      )}
    </label>
  )
}
